module.exports = __webpack_public_path__ + "img/story.c38dce2f.jpg";